//import React from 'react'
import Home from '../../components/StudentDashboard/Home'
import Profile from '../../components/StudentDashboard/Profile'
import Resources from '../../components/StudentDashboard/Resources'
import Library from '../../components/StudentDashboard/Library'
import Courses from '../../components/StudentDashboard/Courses'
import Schedule from '../../components/StudentDashboard/Schedule'

/**
 * This file exports the student dashboard components.
 * All components are imported from the StudentDashboard directory.
 *
 * TODO: Consider adding unit tests for these components.
 * TODO: Ensure all imported components implement proper prop-types.
 */

// Export named components with Home also exported as DashboardHome for backward compatibility
export {
  Home as DashboardHome,
  Home,
  Profile,
  Resources,
  Library,
  Courses,
  Schedule,
}

// Define the dashboard components object
const dashboardComponents = {
  DashboardHome: Home,
  Home,
  Profile,
  Resources,
  Library,
  Courses,
  Schedule,
}

// Export the dashboard components object as default
export default dashboardComponents

// The local component implementations have been removed in favor of the imported components.
// If you need to reference the previous implementations, check the git history.
